// extracted by mini-css-extract-plugin
module.exports = {"workGrid":"styles_workGrid__2oYTV"};